const fillerWords = [
    "to",
    "being",
    "through",
    "for",
    "is",
    "by",
    "and",
    "if",
    "a",
    "the",
    "Arabic",
    "plural",
    "verb",
    "stem",
    "of",
    "do",
    "it",
    "be",
    "become",
    "up",
    "when",
    "out",
    "up",
    "inflected",
    "attributive",
    "etc",
    "ie",
    "literal",
    "figurative",
    "lit",
    "fig",
    "make",
    "etc.",
    "",
];

export default fillerWords;
